import { render, staticRenderFns } from "./ImageVideoGallery.vue?vue&type=template&id=25643afe&"
import script from "./ImageVideoGallery.ts?vue&type=script&lang=ts&"
export * from "./ImageVideoGallery.ts?vue&type=script&lang=ts&"
import style0 from "./ImageVideoGallery.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports